"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _createStyles = require("../styles/createStyles");
var _capitalizeFirstWord = require("../utilities/capitalizeFirstWord");
const _excluded = ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"];
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const breakpointsList = Object.keys(theme.busbud.breakpoints.values);
  return {
    /* Styles applied to the root element. */
    root: {
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.busbud.spacing(1),
      paddingRight: theme.busbud.spacing(1),
      [theme.busbud.breakpoints.up('sm')]: {
        paddingLeft: theme.busbud.spacing(2),
        paddingRight: theme.busbud.spacing(2)
      },
      [theme.busbud.breakpoints.up('md')]: {
        paddingLeft: theme.busbud.spacing(3),
        paddingRight: theme.busbud.spacing(3)
      }
    },
    /* Styles applied to the root element if `disableGutters={true}`. */
    disableGutters: {
      paddingLeft: 0,
      paddingRight: 0
    },
    /* Styles applied to the root element if `fixed={true}`. */
    fixed: breakpointsList.reduce((acc, breakpoint) => {
      const value = theme.busbud.breakpoints.values[breakpoint];
      if (value !== 0) {
        acc[theme.busbud.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }
      return acc;
    }, {}),
    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: {
      [theme.busbud.breakpoints.up('xs')]: {
        maxWidth: Math.max(theme.busbud.breakpoints.values.xs, 444)
      }
    },
    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: {
      [theme.busbud.breakpoints.up('sm')]: {
        maxWidth: theme.busbud.breakpoints.values.sm
      }
    },
    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: {
      [theme.busbud.breakpoints.up('md')]: {
        maxWidth: theme.busbud.breakpoints.values.md
      }
    },
    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: {
      [theme.busbud.breakpoints.up('lg')]: {
        maxWidth: theme.busbud.breakpoints.values.lg
      }
    },
    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: {
      [theme.busbud.breakpoints.up('xl')]: {
        maxWidth: theme.busbud.breakpoints.values.xl
      }
    }
  };
});
function getBoxWidthClassKey(maxWidth) {
  return `maxWidth${(0, _capitalizeFirstWord.capitalizeFirstWord)(maxWidth)}`;
}

/**
 * **❗️ DEPRECATED**: Consider to use flex or grid layout instead.
 * Check the [documentation](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/layout-cheatsheet-grid--docs)
 *
 * @deprecated
 */
const Container = /*#__PURE__*/_react.default.forwardRef(function Container(props, ref) {
  const {
      classes: classesOverrides,
      className,
      component: Component = 'div',
      disableGutters = false,
      fixed = false,
      maxWidth = 'lg'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles({
    classesOverrides
  });
  const classNames = cx(classes.root, maxWidth !== false && classes[getBoxWidthClassKey(maxWidth)], {
    [classes.fixed]: fixed,
    [classes.disableGutters]: disableGutters
  }, className);
  // @ts-ignore TS2590
  return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    className: classNames,
    ref: ref
  }, other));
});
var _default = exports.default = Container;